import { PERMISSIONS } from '../../core/utils/permissions';

export const DASHBOARD_PERMISSIONS = {
  READ: PERMISSIONS.DASHBOARD_READ,
};
